import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import Pages from './pages';
import Organizations from './organizations';
import Roles from './roles';
import UserRoles from './userRoles';
import Devices from './devices';
import Users from './users';
import Firmwares from './firmwares';

import withAdminLayout from '../../layout/withAdminLayout';

const Admin = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Pages />} />
        <Route path="pages/*" element={<Pages />} />
        <Route path="dashboards" element={<Pages />} />
        <Route path="admin" element={<Pages />} />
        <Route path="organizations/*" element={<Organizations />} />
        <Route path="/admin/roles/*" element={<Roles />} />
        <Route path="/roles/*" element={<UserRoles />} />
        <Route path="devices/*" element={<Devices />} />
        <Route path="users/*" element={<Users />} />
        <Route path="/admin/firmwares/*" element={<Firmwares />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
